require('./cmHome.scss');
const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @commons
const { formatText } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const { CmWalletBuy } = require('../cmWalletBuy/cmWalletBuy');
const CmWalletBuySuccess = require('../cmWalletBuy/cmWalletBuySuccess/cmWalletBuySuccess');
const CmErrorState = require('../cmErrorState/cmErrorState');
const CmHeaderSubPage = require('../cmHeaderSubPage/cmHeaderSubPage');
const {
    BrokerMiFIDBehavior,
} = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @utilities
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @actions
const actions = require('wealth-cm/actions/actions');
const cmLegalDocuments = require('wealth-cm/actions/cmLegalDocuments');
const BrokerFundLegalDocument = require('actions/brokerFundLegalDocument');
const cmWalletBuyActions = require('wealth-cm/actions/cmWalletBuy');
const errorActions = require('actions/brokerError');
const featureFlag = require('actions/flagBasedFeatures');
const blockedAccounts = require('actions/blockedAccounts');

// @helpers
const { downloadAsFile, base64ToBlob } = require('utilities/APIRequestHelper');
const { getFinalTitle } = require('core/i18n').i18n;

// @constants
const {
    BROKER_MIFID_VERSION_2,
    CONTENT_TYPE_PDF,
    BROKER_CONVENIENCE_MIFID_CM_BUY,
} = require('constants/index');
const {
    CM_BROKER_PG_URL,
    CM_BUY_TYPE_MONEY,
    CM_WIZARD_FIRST_STEP,
} = require('wealth-cm/constants/constants');

class CmHome extends React.Component {
    constructor(props) {
        super(props);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    componentDidMount() {
        const { immCmWalletBuy, location } = this.props;

        if (!immCmWalletBuy.get('isSynchronized')) {
            const query = new URLSearchParams(location.search);
            const params = {
                id: query.get('id'),
                type: query.get('type'),
                amount: +query.get('amount'),
                isDiy: query.get('isDiy') === 'true',
                returnUrl: query.get('returnUrl'),
            };
            this.props.sync(params);
        }
    }

    componentWillReceiveProps(newProps) {
        this.handleDocumentsFetched(newProps);
    }

    componentDidUpdate(prevProps) {
        const { immCmWalletBuy } = this.props;
        const isPortfolioInfoFetched = immCmWalletBuy.get(
            'isPortfolioInfoFetched',
        );
        const isRiskPortfolioCategorizationFetched = immCmWalletBuy.get(
            'isRiskPortfolioCategorizationFetched',
        );
        const isSynchronized = immCmWalletBuy.get('isSynchronized');

        if (isSynchronized != prevProps.immCmWalletBuy.get('isSynchronized')) {
            const amount = parseFloat(
                immCmWalletBuy.getIn(['simulation', 'amount'], 0),
            );
            const portfolioId = immCmWalletBuy.getIn(['simulation', 'id']);

            if (!immCmWalletBuy.get('isRiskPortfolioCategorizationFetched')) {
                this.props.getPortfolioRiskCategorization(
                    portfolioId,
                    this.props.history,
                );
            }

            if (!immCmWalletBuy.get('isPortfolioInfoFetched')) {
                const publicAmount = immCmWalletBuy.getIn([
                    'simulation',
                    'publicAmount',
                ]);
                this.props.getPortfolioInfo(
                    amount,
                    portfolioId,
                    publicAmount,
                    this.props.history,
                );
            }
        }

        if (
            isPortfolioInfoFetched &&
            !immCmWalletBuy.get('isFetchingFundsMinAmounts') &&
            !immCmWalletBuy.get('isFundsMinAmountsFetched')
        ) {
            this.props.getFundsMinAmounts(this.props.history);
        }

        if (isPortfolioInfoFetched && isRiskPortfolioCategorizationFetched) {
            const isinId = immCmWalletBuy.getIn([
                'walletRisk',
                'mostRestrictiveIsin',
            ]);
            const productName = trim(
                immCmWalletBuy.getIn(['portfolios', 0, 'portfolioDesc']),
            );
            if (!isinId || !productName) {
                this.props.showError();
            }
        }
    }

    handleDocumentClick(isin) {
        const { immCmLegalDocuments, fetchUnifiedDocument } = this.props;

        if (immCmLegalDocuments.getIn(['byId', isin, 'isFetched'])) {
            this.openLegalDocuments(immCmLegalDocuments, isin);
        } else {
            fetchUnifiedDocument(isin);
        }
    }

    downloadPDF(immCmLegalDocuments, isin) {
        const dataBlock = immCmLegalDocuments.getIn([
            'byId',
            isin,
            'fundTransactionCostBase64Data',
        ]);
        const dataID = immCmLegalDocuments.getIn([
            'byId',
            isin,
            'fundTransactionCostObjectId',
        ]);
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${dataBlock}`;
        downloadAsFile(base64ToBlob(base64String), CONTENT_TYPE_PDF, dataID);
    }

    openLegalDocuments(immCmLegalDocuments, isin) {
        window.open(
            immCmLegalDocuments.getIn(['byId', isin, 'unifiedDocumentUrl']),
            '_blank',
        );
    }

    handleDocumentsFetched(newProps) {
        const { immCmLegalDocuments } = this.props;
        if (
            immCmLegalDocuments.get('activeIsin') !==
            newProps.immCmLegalDocuments.get('activeIsin')
        ) {
            this.openLegalDocuments(
                newProps.immCmLegalDocuments,
                newProps.immCmLegalDocuments.get('activeIsin'),
            );
        }
    }

    getSimulationUrl() {
        const { immCmWalletBuy } = this.props;
        const publicSiteUrl = getPublicSiteUrl(false);
        const simulationUrl = `${publicSiteUrl}/${immCmWalletBuy.getIn([
            'simulation',
            'returnPath',
        ])}`;
        return simulationUrl;
    }

    buildBrokerMiFIDBehavior(immCmWalletBuy) {
        const { setAllDocumentsRead, removeIntervener } = this.props;
        const isinId = immCmWalletBuy.getIn([
            'walletRisk',
            'mostRestrictiveIsin',
        ]);
        const productName = trim(
            immCmWalletBuy.getIn(['portfolios', 0, 'portfolioDesc']),
        );
        const productMifidId = immCmWalletBuy.getIn([
            'walletRisk',
            'riskPortfolioMiFid2',
        ]);
        const continuationUrl =
            this.props.location.pathname + this.props.location.search;
        const mifidOptions = {
            operationType: BROKER_CONVENIENCE_MIFID_CM_BUY,
        };
        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productIsinId={isinId}
                productMifidId={productMifidId}
                productName={productName}
                productUrl=""
                cancelPath={this.getSimulationUrl()}
                continuationUrl={continuationUrl}
                mifidOptions={mifidOptions}
            >
                <div className="row">
                    <div className="col-xs-12 cm-landing__wizard-body">
                        <CmWalletBuy
                            immAccounts={this.props.immAccounts}
                            getBlockedAccounts={this.props.getBlockedAccounts}
                            getPortfolioInfo={this.props.getPortfolioInfo}
                            onLegalDocumentClick={this.handleDocumentClick}
                            getContractsAsOriginTransfer={
                                this.props.getContractsAsOriginTransfer
                            }
                            setBuyType={this.props.setBuyType}
                            setOriginFund={this.props.setOriginFund}
                            saveOriginFundInfo={this.props.saveOriginFundInfo}
                            immBrokerLegalDocumentation={
                                this.props.immBrokerLegalDocumentation
                            }
                            reportCompleted={() => setAllDocumentsRead()}
                            fetchFeatureFlag={this.props.fetchFeatureFlag}
                            validateCheck={this.props.validateCheck}
                            removeIntervener={removeIntervener}
                        />
                    </div>
                </div>
            </BrokerMiFIDBehavior>
        );
    }

    getBreadCrumb() {
        return [
            {
                text: formatText('brokerCM-breadCrumbInvestments'),
                url: CM_BROKER_PG_URL,
            },
            {
                text: formatText('brokerCM-breadCrumbModelWallets'),
                url: this.getSimulationUrl(),
            },
            {
                text: formatText('brokerCM-brokerCM_breadCrumbBuyFunds'),
            },
        ];
    }

    render() {
        const {
            immCmWalletBuy,
            immAccounts,
            immBrokerConvenienceMiFIDTest,
        } = this.props;
        const isSynchronized = immCmWalletBuy.get('isSynchronized');
        const eventTag = immCmWalletBuy.get('eventTag');

        let successContent, content;
        let typeError = false;

        if (isSynchronized) {
            if (
                immCmWalletBuy.get('errorConfirmation') ||
                immCmWalletBuy.get('errorValidation')
            ) {
                successContent = (
                    <div className="row">
                        <div className="col-xs-12 cm-landing__wizard-body-transfer--error">
                            <CmErrorState
                                immCmWalletBuy={immCmWalletBuy}
                                immAccounts={immAccounts}
                                onLegalDocumentClick={this.handleDocumentClick}
                            />
                        </div>
                    </div>
                );
                typeError = true;
            } else {
                successContent = (
                    <div className="row">
                        <div className="col-xs-12 cm-landing__wizard-body--success">
                            <CmWalletBuySuccess
                                immCmWalletBuy={immCmWalletBuy}
                                immAccounts={immAccounts}
                                onLegalDocumentClick={this.handleDocumentClick}
                                eventTag={eventTag}
                            />
                        </div>
                    </div>
                );
            }

            const mappingBreadcrumb = this.getBreadCrumb();
            let headerSubPage;
            let titleKey = typeError
                ? 'brokerCM-brokerCM_walletBuyFailedTitle'
                : 'brokerCM-walletBuySuccessTitle';
            const isTransferWithMoney = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_FIRST_STEP,
                'isTransferWithMoney',
            ]);

            if (
                (immCmWalletBuy.get('buyType') !== CM_BUY_TYPE_MONEY ||
                    isTransferWithMoney) &&
                !immCmWalletBuy.get('errorValidation')
            ) {
                titleKey = typeError
                    ? 'brokerCM-brokerCM_buyStepSuccessTransferWithMoneyFailure'
                    : 'brokerCM-brokerCM_buyStepSuccessTransferWithMoneySucess';
            }

            const okHeader = (
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle(
                        'brokerCM-cmLandingBuyModelWalletTitle',
                    )}
                    isSubtitleLeftCapital={true}
                ></OKHeaderSubPage>
            );

            const cmHeader = (
                <CmHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    titleKey={titleKey}
                    typeError={typeError}
                />
            );

            if (
                immCmWalletBuy.get('submitSuccessful') ||
                immCmWalletBuy.get('errorConfirmation') ||
                immCmWalletBuy.get('errorValidation')
            ) {
                content = successContent;
                headerSubPage = cmHeader;
            } else {
                const isInfoFetched =
                    immCmWalletBuy.get('isPortfolioInfoFetched') &&
                    !immCmWalletBuy.get(
                        'isFetchingRiskCategorizationPortfolio',
                    );
                if (isInfoFetched) {
                    content = this.buildBrokerMiFIDBehavior(immCmWalletBuy);
                    if (immBrokerConvenienceMiFIDTest.get('resultDisplayed')) {
                        headerSubPage = okHeader;
                    }
                } else {
                    content = <LoadingSection />;
                }
            }

            return (
                <article className="cm-landing">
                    <OKCover size="medium" section="cm">
                        {headerSubPage}
                    </OKCover>
                    <section className="cm-landing__body">{content}</section>
                </article>
            );
        } else {
            return <LoadingSection />;
        }
    }
}

CmHome.propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    sync: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerLegalDocumentation: PropTypes.object.isRequired,
    immCmWalletBuy: PropTypes.object.isRequired,
    immCmLegalDocuments: PropTypes.object.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    fetchUnifiedDocument: PropTypes.func.isRequired,
    getPortfolioInfo: PropTypes.func.isRequired,
    getContractsAsOriginTransfer: PropTypes.func.isRequired,
    getPortfolioRiskCategorization: PropTypes.func.isRequired,
    getFundsMinAmounts: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    setBuyType: PropTypes.func,
    setOriginFund: PropTypes.func,
    saveOriginFundInfo: PropTypes.func,
    removeIntervener: PropTypes.func,
    setAllDocumentsRead: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    validateCheck: PropTypes.func.isRequired,
};

module.exports.CmHome = connect(
    state => ({
        immCmWalletBuy: state.cm,
        immAccounts: state.accounts,
        immCmLegalDocuments: state.cmLegalDocuments,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerLegalDocumentation: state.brokerLegalDocumentation,
    }),
    {
        sync: actions.sync,
        fetchUnifiedDocument: cmLegalDocuments.fetchUnifiedDocument,
        fetchFeatureFlag: featureFlag.requestFlagBasedFeatures,
        getPortfolioInfo: cmWalletBuyActions.getPortfolioInfo,
        getContractsAsOriginTransfer:
            cmWalletBuyActions.getContractsAsOriginTransfer,
        getPortfolioRiskCategorization:
            cmWalletBuyActions.getPortfolioRiskCategorization,
        showError: errorActions.show,
        fetchFundTransactionCost:
            BrokerFundLegalDocument.fetchFundTransactionCost,
        getFundsMinAmounts: cmWalletBuyActions.getFundsMinAmounts,
        setBuyType: cmWalletBuyActions.setBuyType,
        setOriginFund: cmWalletBuyActions.setOriginFund,
        saveOriginFundInfo: cmWalletBuyActions.saveOriginFundInfo,
        setAllDocumentsRead: cmWalletBuyActions.setAllDocumentsRead,
        getBlockedAccounts: blockedAccounts.getBlockedAccounts,
        removeIntervener: cmWalletBuyActions.removeIntervener,
        validateCheck: cmWalletBuyActions.validateCheck,
    },
)(withRouter(CmHome));
